import React, { useCallback } from 'react';

import { useLoggedInUserLoginData } from '~/components/Auth/useLoggedInUserLoginData';
import { DraggableDialog } from '~/components/Dialogs/components/DraggableDialog';
import { ChangePasswordForm } from '~/features/ChangePassword/ChangePasswordForm';
import { useLibraryComponentContext } from '~/library/components/LibraryComponentContext';
import { redirectToLogOut } from '~/utils/helper';

type Props = {
  open: boolean;
  onClose: () => void;
};

export const ChangePasswordDialog = (props: Props) => {
  const { open, onClose } = props;

  const { onUpdateLegacy } = useLibraryComponentContext();

  const userLoginData = useLoggedInUserLoginData();

  const onUpdate = useCallback(() => {
    redirectToLogOut('Password change completed');

    if (onUpdateLegacy) {
      onUpdateLegacy(['changePasswordUpdate']);
    }
  }, [onUpdateLegacy]);

  return (
    <DraggableDialog open={open}>
      <ChangePasswordForm
        username={userLoginData.fLoginUsername}
        onUpdate={onUpdate}
        onClose={onClose}
      />
    </DraggableDialog>
  );
};
